import { formatIsoDateTimeAsStated } from '@core/utils/date-utils';
import { formatDurationFromIso, isIsoDuration } from '@core/utils/time-utils';

/**
 * Whether `text` is `raw` printed as a duration or a date-time. A value counts as one only where
 * it was printed as one: a uid such as `P1D` parses as a duration but is printed raw, and
 * reading it as a duration would have the list reformat an identifier.
 */
export function printedKind(
  raw: string,
  text: string,
  lang: string
): 'duration' | 'datetime' | null {
  if (isIsoDuration(raw) && formatDurationFromIso(raw) === text) return 'duration';
  if (formatIsoDateTimeAsStated(raw, lang) === text) return 'datetime';
  return null;
}
